<template>
  <div class="w-100">
    <b-row class="mt-2">
      <b-col>
        <b-card class="super-card shadow-sm h-100" title="Initial margin">
          <span
            :class="results.im > 0 ? 'text-success' : 'text-danger'"
            class="super-card-value"
            >{{ results.initialMargin }}</span
          >
        </b-card>
      </b-col>
      <b-col>
        <b-card class="super-card shadow-sm h-100" title="Present value">
          <span
            :class="results.pv > 0 ? 'text-success' : 'text-danger'"
            class="super-card-value"
            >{{ results.pv }}</span
          >
        </b-card>
      </b-col>
    </b-row>

    <collapsable
      class="mt-2 w-100"
      content="Profits and Losses"
      :visible="true"
    >
      <b-row>
        <b-col>
          <b-card class="shadow-sm">
            <Plotly :data="data" :layout="layout"></Plotly>
          </b-card>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <b-card class="shadow-sm">
            <Plotly :data="scatterData" :layout="scatterLayout"></Plotly>
          </b-card>
        </b-col>
      </b-row>
    </collapsable>

    <collapsable class="mt-2 w-100" content="Sensitivities" :visible="true">
      <Sensitivity
        class="w-100"
        v-for="sensitivity in results.sensitivities"
        :sensitivity="sensitivity"
        v-bind:key="sensitivity.marketDataName"
      >
      </Sensitivity>
    </collapsable>
  </div>
</template>

<script>
import { Plotly } from "vue-plotly";
import Sensitivity from "@/components/Sensitivity.vue";
import { styledLayout } from "@/utils/plotlyLayout.js";
export default {
  props: {
    results: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      data: [
        {
          x: this.results.pnlVector,
          type: "histogram"
        }
      ],
      layout: styledLayout({
        title: "Profits and Losses histogram"
      }),
      scatterData: [
        {
          x: [],
          y: this.results.pnlVector,

          mode: "markers",
          type: "scatter"
        }
      ],
      scatterLayout: styledLayout({
        title: "PnL Time series",
        colorway: ["#cd7eaf", "#f3cec9", "#e7a4b6"]
      })
    };
  },
  async mounted() {
    this.scatterData[0].x = await this.$client.getScenarioInfo();
  },
  methods: {
    updateData(pnlVector) {
      this.data[0].x = pnlVector;
      this.scatterData[0].y = pnlVector;
    }
  },
  components: { Plotly, Sensitivity }
};
</script>
